import useFormatNumber from '@/utils/hooks/format/useFormatNumber';
import useSubscription from '@/utils/hooks/swr/pricing/useSubscription';
// Utils
import useUser from '@/utils/hooks/swr/useUser';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import { FREE_PLAN } from '@/types/pricingTypes/planType';

export function PlanPrice() {
    const { t } = useTranslation('commons');
    const { user } = useUser();
    const { subscription } = useSubscription();
    const { formatPriceSymbolNoSpace } = useFormatNumber(user?.settings?.numbers_format);

    if (subscription.product_key === 'trial') {
        return (
            <div className="font-GBold text-2xl" data-testid="trial-price-section">
                {t('pricing.on_trial')}
            </div>
        );
    }

    return (
        <div className="flex flex-col space-y-1 text-sm">
            {subscription.product_key === FREE_PLAN ? (
                <span className="font-GBold text-2xl">{t('pricing.free_plan')}</span>
            ) : (
                <>
                    <span className="flex items-baseline gap-x-0.5">
                        <span className="font-GBold text-2xl">
                            {formatPriceSymbolNoSpace(
                                subscription.total_monthly,
                                subscription.currency
                            )}
                        </span>
                        /<span>{t('pricing.month')}</span>
                    </span>
                    <span className="font-GMedium text-icoGray-500 dark:text-icoDarkMode-wolf">
                        {t(`pricing:billed_${subscription.frequency}_with_tax`)}
                    </span>
                </>
            )}
        </div>
    );
}
